// extracted by mini-css-extract-plugin
export var container = "_i5-0";
export var segment = "_i5-2";
export var segmentActive = "_i5-3";
export var track = "_i5-1";